export default __webpack_public_path__ + "static/media/提示2.56a85079.svg";